import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class MasterShiftService {
  
get baseUrl2(): string { return Constants.CORE_API_BASE_URL; }  
  constructor(private http: HttpClient) { }
  getGroupData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.baseUrl2 + 'Common/GetGroup', data, { headers: header });
  }
  //NOT IN USE
  // getShift(data: any): Observable<any> {
  //   return this.http.post<any>(this.kpibaseUrl + 'generalshift', data);
  // }

  // getOneGeneralShift(data: any): Observable<any> {
  //   return this.http.post<any>(this.kpibaseUrl + 'onegeneralshift', data);
  // }
  // addGeneralShift(data: any): Observable<any[]> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.post<any[]>(this.baseUrl + 'addgeneralhift', data, { headers: header });
  // }
  // getGeneralShifts(data: any): Observable<any> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.post<any>(this.baseUrl + 'generalshift', data, { headers: header });
  // }
  // deleteShift(data: any): Observable<any> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.post<any>(this.baseUrl + 'deletegeneralshift', data, { headers: header });
  // }
  // updateShift(data: any): Observable<any[]> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.put<any[]>(this.baseUrl + 'generalshift', data, { headers: header });
  // }
}
